import React, { Component } from 'react';
import { connect } from "react-redux";
import { OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import ReportIssue from '../Modals/ReportIssue';
import {manageReportIssueModal,setScreenShot} from "../../action/index.js";
import html2canvas from 'html2canvas';
import * as htmlToImage from 'html-to-image';
import { const_var,params } from '../../redux/reducers/reducer';
import ReportError from '../../assets/images/report-error.svg';

class ReportIssueComp extends Component {
    constructor(props) {
        super(props);
    }
    
    handleReportClick=()=>{
        document.querySelector('body').classList.add('waiting-report-popup');
        this.captureElement()
    }

    captureElement = async () => {
        this.props.manageReportIssueModal(true);
       
        let capture = await html2canvas(document.body).then(function(canvas) {
            return canvas
        });
        // await htmlToImage.toPng(document.getElementById("root"),{ quality: 1 })
        //             .then(function (dataUrl) {
        //               console.log(dataUrl,"dataUrl")
        //             })     
        let base64image = await capture.toDataURL("image/png", 1.0);
        this.props.setScreenShot(base64image);
         document.querySelector('body').classList.remove('waiting-report-popup');
       
    }

    render() {
        if(this.props.const_var.loginSession != true)
        {
            return null;
        }
        return (
            <>            
               <OverlayTrigger    
               trigger="hover"                         
                    placement="top"
                    overlay={(
                        <Popover className="price-box-popover">          
                          <Popover.Content>
                            <p className="mb-0 f-12 "> We value your input! Please report any issues by clicking on the button below.
                            </p>
                        </Popover.Content>
                        </Popover>
                      )}>
                    <a className={`${this.props.showReportIssueModal==true ? 'active-error-modal report-error':'report-error'} `} onClick={()=>this.handleReportClick()}> 
                     <span className="icon icon-report"></span> 
                     <div className="spinner"></div>
                    <span className="text">Report Error</span>
                    </a>
                </OverlayTrigger> 
            
                <ReportIssue show={const_var.showReportIssueModal} handleClose={()=>{this.setState({enableClick: true});this.props.manageReportIssueModal(false)}} />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {...state.reducer}
  }
  const mapDispatchToProps = {
    manageReportIssueModal,
    setScreenShot
  }
  
  export default connect(
  mapStateToProps,
  mapDispatchToProps
  )(ReportIssueComp);
  
